import TweetBlock from './TweetBlock'
export { TweetLink } from './TweetBlock'
export default TweetBlock
